import React from 'react';
import { button } from './styles.module.scss';

const ButtonCloseOverlay = ({ closeOverlay }) => {
  return (
    <button type="button" onClick={closeOverlay} className={button}></button>
  );
};

export default ButtonCloseOverlay;
